/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'arrow-left': {
    width: 7,
    height: 12,
    viewBox: '0 0 7 12',
    data: '<path pid="0" d="M6.707 10.288l-3.88-3.88 3.88-3.88a.996.996 0 10-1.41-1.41l-4.59 4.59a.996.996 0 000 1.41l4.59 4.59c.39.39 1.02.39 1.41 0 .38-.39.39-1.03 0-1.42z" _fill="#A9B7C3" fill-rule="evenodd"/>'
  }
})
